import { createI18n } from 'vue-i18n'

import en from '~/locales/en.json'
import zh from '~/locales/zh.json'

// 从 localStorage 获取保存的语言设置，默认为 'en-US'
function getStoredLocale(): string {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('localLanguage')
    return stored || 'en-US'
  }
  return 'en-US'
}

export const i18n = createI18n({
  legacy: false,
  locale: getStoredLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'en-US': en,
    'zh-CN': zh,
  },
})
